import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/auth/logout.ts
import { Exception } from "@wbk/logger";
var logout = () => __async(void 0, null, function* () {
  var _a, _b;
  try {
    yield fetchClient({
      url: "/auth/logout",
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.authApi,
      options: {
        method: "POST"
      }
    });
    return true;
  } catch (error) {
    throw new Exception({ error, name: "logoutException" });
  }
});

export {
  logout
};
//# sourceMappingURL=chunk-RIHYP73M.mjs.map